import React, { useEffect, useState, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import apiService from "../../services/api";
import "../../styles/global.css";

export default function AdminItemDetails() {
  const { restaurantId, itemId } = useParams();
  const navigate = useNavigate();

  const [item, setItem] = useState(null);
  const [editing, setEditing] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    description: "",
    price: "",
    category: "",
    image: null,
    model: null,
  });

  const fetchItem = useCallback(async () => {
    try {
  
      console.log("Fetching item:", itemId);
  
      const data =
        await apiService.getItemDetails(itemId);
  
      console.log("Item data:", data);
  
      setItem(data);
  
      setFormData({
        name: data.name,
        description: data.description,
        price: data.price,
        category: data.category || "",
      });
  
    } catch (error) {
  
      console.error(error);
  
      alert("Failed to load item");
  
    }
  }, [itemId]);
  
useEffect(() => {
  fetchItem();
}, [fetchItem]);


  const handleUpdate = async () => {
    try {
      console.log("Updating item...");

      const fd = new FormData();

      fd.append("name", formData.name);
      fd.append("description", formData.description);
      fd.append("price", formData.price);
      fd.append("category", formData.category);

      if (formData.image) {
        fd.append("image", formData.image);
      }

      if (formData.model) {
        fd.append("model", formData.model);
      }

      await apiService.updateRestaurantItem(
        restaurantId,
        itemId,
        fd
      );

      alert("Item updated successfully");

      setEditing(false);

      fetchItem();

    } catch (error) {
      console.error(error);
      alert("Update failed");
    }
  };

  if (!item)
    return <p>Loading item...</p>;

  return (
    <div className="section">
      <div className="container">

        {/* Back Button */}

        <button
          className="btn btn-secondary"
          style={{ marginBottom: "15px" }}
          onClick={() => navigate(-1)}
        >
          ⬅ Back
        </button>

        <h1>🍴 Item Details</h1>

        <div className="card">

          <img
            src={item.imageUrl}
            alt={item.name}
            style={{
              width: "250px",
              borderRadius: "10px",
            }}
          />

          <h2>{item.name}</h2>

          <p>{item.description}</p>

          <h3>₹ {item.price}</h3>

          {/* Category Display */}

          <p>
            <strong>Category:</strong>{" "}
            {item.category || "Not specified"}
          </p>

          {item.modelUrl && (
            <p>
              3D Model Available
            </p>
          )}

          <button
            className="btn btn-primary"
            onClick={() => setEditing(true)}
          >
            Edit Item
          </button>

        </div>

        {/* EDIT FORM */}

        {editing && (

          <div className="card">

            <h3>Edit Item</h3>

            <input
              type="text"
              value={formData.name}
              className="form-input"
              placeholder="Food Name"
              onChange={(e) =>
                setFormData({
                  ...formData,
                  name: e.target.value,
                })
              }
            />

            <textarea
              value={formData.description}
              className="form-input"
              placeholder="Description"
              onChange={(e) =>
                setFormData({
                  ...formData,
                  description:
                    e.target.value,
                })
              }
            />

            <input
              type="number"
              value={formData.price}
              className="form-input"
              placeholder="Price"
              onChange={(e) =>
                setFormData({
                  ...formData,
                  price: e.target.value,
                })
              }
            />

            {/* Category Dropdown */}

            <select
              value={formData.category}
              className="form-input"
              onChange={(e) =>
                setFormData({
                  ...formData,
                  category: e.target.value,
                })
              }
            >
              <option value="">
                Select Category
              </option>

              <option value="Starters">
                Starters
              </option>

              <option value="Main Course">
                Main Course
              </option>

              <option value="Biryani">
                Biryani
              </option>

              <option value="Drinks">
                Drinks
              </option>

              <option value="Desserts">
                Desserts
              </option>

            </select>

            <input
              type="file"
              accept="image/*"
              className="form-input"
              onChange={(e) =>
                setFormData({
                  ...formData,
                  image:
                    e.target.files[0],
                })
              }
            />

            <input
              type="file"
              accept=".glb,.gltf"
              className="form-input"
              onChange={(e) =>
                setFormData({
                  ...formData,
                  model:
                    e.target.files[0],
                })
              }
            />

            <button
              className="btn btn-primary"
              onClick={handleUpdate}
            >
              Save Changes
            </button>

          </div>

        )}

      </div>
    </div>
  );
}